import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const ConfirmMergeOrgModalLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "ConfirmMergeOrgModal" */
      './ConfirmMergeOrgModal'
    ),
  loading: LoadingModal,
});
